import axiosClient from '../axiosClient';
import type { paths, components } from '@/api/types/auto-generated';

type TableEntry = paths['/api/v2/table']['get']['responses']['200']['content']['application/json']
export type SaveTableColumnDefinitionRequest = components['schemas']['UpdateColumnDefinitionRequest'];

export interface ToggleColumnRequest {
  tableDefinitionId: number;
  columnName: string;
  newValue: boolean;
}

export interface CreateTableDefinitionRequest {
  dbSchemaName: string;
  dbTableName: string;
}

export interface CreateTableRequest {
  dbSchemaName: string;
  dbTableName: string;
  columnTypes?: Array<{
    colName: string;
    colLabel: string;
    colType: string;
    colSize?: string;
    isNullable: boolean;
    defaultValue?: string;
    isPrimaryKey: boolean;
  }>;
  systemObjectId?: number | null;
}

export interface CopyTableRequest {
  fromSchemaName: string;
  fromTableName: string;
  toSchemaName: string;
  toTableName: string;
  copyData: boolean;
  systemObjectId?: number | null;
}

export interface LinkTableRequest {
  systemObjectId: number;
  tableDefinitionId: number;
}

export interface UnlinkTableRequest {
  systemObjectId: number;
}

export interface DeleteTableRequest {
  tableDefinitionId: number;
}

// GET endpoints
export async function fetchTableByDefinitionId (tableDefinitionId: number): Promise<TableEntry | undefined> {
  console.log('Kaller fetchTableByDefinitionId med tableDefinitionId:', tableDefinitionId);
  const response = await axiosClient.get('v2/table', {
    params: { tableDefinitionId },
  });
  console.log('Respons fra API i fetchTableByDefinitionId:', response);
  return response.data; // returner hele objektet
}

export async function fetchTableBySystemObjectId (systemObjectId: number): Promise<TableEntry | undefined> {
  const response = await axiosClient.get('v2/table', {
    params: { systemObjectId },
  });
  return response.data; // returner hele objektet
}

// POST endpoints
export async function saveTableColumnDefinition (
  tableDefinitionId: number,
  request: SaveTableColumnDefinitionRequest
): Promise<void> {
  await axiosClient.post('v2/table/column/definition', request, {
    params: { tableDefinitionId }
  });
}

export async function createTableDefinition (
  request: CreateTableDefinitionRequest
): Promise<{ tableDefinitionId: number }> {
  const response = await axiosClient.post('v2/database/system/create-table-definition', request);
  return response.data;
}

export async function createTable (
  request: CreateTableRequest
): Promise<{ tableDefinitionId: number }> {
  const response = await axiosClient.post('v2/database/system/create-table', request);
  return response.data;
}

export async function copyTable (
  request: CopyTableRequest
): Promise<{ tableDefinitionId: number }> {
  const response = await axiosClient.post('v2/database/system/copy-table', request);
  return response.data;
}

// PUT endpoints
export async function toggleColumnReadOnly (
  request: ToggleColumnRequest
): Promise<void> {
  await axiosClient.put('v2/table/column/readonly', null, {
    params: request
  });
}

export async function toggleColumnIncludeInputFormNew (
  request: ToggleColumnRequest
): Promise<void> {
  await axiosClient.put('v2/table/column/include-input-form-new', null, {
    params: request
  });
}

export async function linkTable (
  request: LinkTableRequest
): Promise<void> {
  await axiosClient.put('v2/database/system/table/link', null, {
    params: request
  });
}

export async function unlinkTable (
  request: UnlinkTableRequest
): Promise<void> {
  await axiosClient.put('v2/database/system/table/unlink', null, {
    params: request
  });
}

// DELETE endpoints
export async function deleteTable (
  request: DeleteTableRequest
): Promise<void> {
  await axiosClient.delete('v2/database/system/table', {
    params: request
  });
}
